import {Fragment, useState, useEffect} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {FormatDisplay} from '../../../shared/format';

import {ToastService} from '../../../AppToast';
import {ConfirmDialogService} from '../../../AppConfirmDialog';

import {ActionLogService} from '../ActionLogService';

export const DialogViewHistory = (props) => {

  const code = 'Invoice';

  const {display, setDisplay, selectedItem} = props;

  const [requiredParams, setRequiredParams] = useState(null);

  const [version, setVersion] = useState(null);
  const [canRollback, setCanRollback] = useState(false);

  useEffect(() => {
    if (display && selectedItem?.id) {
      setRequiredParams({
        code,
        actionId: selectedItem.id
      });
    }
  }, [display, selectedItem]);

  const columns: any = []; 
  columns.push(     
    {field: 'dateAction', header: 'Thời gian', width: 160, dataType: 'custom',
    customCell(rowData: any): any {
      var dateOfInvoice = FormatDisplay.dateTime(rowData.dateAction);
      return dateOfInvoice;
    }
  },
    {field: 'userAction', header: 'Người sử dụng', width: 160},
    {field: 'contentChange', header: 'Nội dung', minWidth: 160,
    dataType: 'custom',
    customCell(rowData: any): any {
      return <div dangerouslySetInnerHTML={{__html: rowData.contentChange}} />;
    }},
  );

  const {render: renderDataTable} = useDataTable({
    columns,
    indexColumnWidth: 40,
    getList: (params) => {
      return ActionLogService.getList(params).then(data => {
        if (setCanRollback) {
          setCanRollback(data && data.totalCount === 0);
        }
        return data;
      });
    },
    requiredParams,
    selectionMode: 'single'
  });
  return (
    <Dialog header="Lịch sử hóa đơn" visible={display} style={{width: '80vw'}} position="top" onHide={() => setDisplay(false)}>
				<Fragment>
				 {renderDataTable()}
				</Fragment>

      <div className="flex justify-content-end mt-2">
        <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-outlined p-button-secondary p-button-sm"/>
      </div>
    </Dialog>
  );
}